








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { MaritalStatusDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxMaritalStatus extends Vue {
  private types: MaritalStatusDto[] | null = [];
  public selectedType = new MaritalStatusDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: MaritalStatusDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: MaritalStatusDto) {
    this.$emit("maritalStatusSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .maritalStatus_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
